import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/Loading";
import { transfersMakeSearch } from "../../../store/actions/transferActions";
import { getTransfersSearch, getTransfersStatuses } from "../../../store/selectors/transferSelectors";
import FormikDatePicker from "./FormikDatePicker";
import { FormikLocation } from "./FormikLocation";
import FormikTimeField from "./FormikTimeField";

type Props = {};

const TransferSearch: FC<Props> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const search = useSelector(getTransfersSearch);
  const statuses = useSelector(getTransfersStatuses);

  const isSearching = statuses.some(s => s.fetching);

  return (
    <div>
      <Formik
        initialValues={search}
        onSubmit={values => {
          dispatch(transfersMakeSearch(values));
        }}
      >
        <Form className="formik-form">
          <div className="formik-input-group fill">
            <div className="formik-input-group-content">
              <FormikLocation direction="departure" placeholder={t("transfer.placeholder.from")} />
            </div>
          </div>
          <div className="formik-input-group fill">
            <div className="formik-input-group-content">
              <FormikLocation placeholder={t("transfer.placeholder.to")} />
            </div>
          </div>
          <div className="formik-input-group width-175">
            <div className="formik-input-group-content">
              <FormikDatePicker name="fdate" placeholder={t("transfer.placeholder.transferDate")} />
              <FormikTimeField name="ftime" />
            </div>
          </div>

          <div className="formik-input-group">
            <div className="formik-input-group-content">
              <button type="submit" className="submit" disabled={isSearching}>
                {isSearching ? <Loading /> : <FontAwesomeIcon icon={["far", "search"]} />}
              </button>
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default TransferSearch;
